<template>
  <v-dialog v-model="dialog" persistent max-width="390">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-show="!!state" color="primary" :disabled="disabled" v-bind="attrs" v-on="on"> {{ title }} </v-btn>
    </template>
    <v-card v-if="state == 'getcode' || state == 'sendcode'">
      <v-card-title class="text-h5"> {{ title }} </v-card-title>
      <v-card-text>
        Введите код который вы получили в СМС на свой телефон.
        <div>
          <v-btn :disabled="sending" color="red darken-1" text @click="onGetCode()"> {{ interval.send > 0 ? interval.send + " " : "" }} Выслать код </v-btn>
        </div>
        <v-otp-input v-model="code" length="6" type="number"></v-otp-input>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red darken-1" @click="onClose()"> Отмена </v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="code?.length !== 6 || confirming" color="green darken-1" @click="onSendCode()">
          {{ interval.confirm > 0 ? interval.confirm + " " : "" }} Отправить
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else-if="state == 'sendsign'">
      <v-card-title class="text-h5">{{ title }} </v-card-title>
      <v-card-text>
        <p>Вы действительно хотите отправить документ на подписание?</p>
        <p></p>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red darken-1" @click="onClose()"> Отмена </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" @click="onSendSign()" :loading="sending" :disabled="sending">
          {{ interval.confirm > 0 ? interval.confirm + " " : "" }} Отправить
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title class="text-h5">Ошибка действия </v-card-title>
      <v-card-actions>
        <v-btn color="red darken-1" @click="onClose()"> Отмена </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    api: String,
    id: [Number, String],
    disabled: { type: Boolean, default: false },
    config: Object,
    values: Object,
    status: Number,
  },
  data() {
    return {
      code: null,
      dialog: false,
      finish: false,
      sending: false,
      error: false,
      confirming: false,
      interval: { send: 0, confirm: 0 },
      timer: { send: null, confirm: null },
      steps_: ["start", "sendsign", "getcode", "sendcode"],
      states_: {
        sendsign: { title: "Отправить на подпись" },
        getcode: { title: "Подписать" },
        sendcode: { title: "Подписать" },
      },
      states: {},
      state: null,
    };
  },
  computed: {
    title() {
      if (!this.state) return false;
      return this.states?.[this.state]?.title || "???";
    },
  },
  watch: {
    status() {
      this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    parseError(e) {
      try {
        if (e.includes("not find data")) return "Не найдены данные";
      } catch (error) {}
      return e;
    },
    init() {
      //let statuses = this.config.statuses;
      let statuses = { 4: "start", 5: "sendsign", 6: "getcode" };
      let states = structuredClone(this.states_);
      //if (this?.config?.states) states = Object.assign(states, this.config.states);
      let state = statuses[this.values.status];
      //console.log({ status: this.values.status, states, state, dd: this.states_ });
      if (state) state = this.steps_?.[this.steps_.indexOf(state) + 1];
      this.state = state;
      this.states = states;
    },
    onClick() {
      if (this.state == "sendsign") {
        this.onSendSign();
      }
    },
    delay(name, n) {
      this.interval[name] = n;
      this.timer[name] = setInterval(() => {
        if (this.interval?.[name]) {
          this.interval[name]--;
        } else clearTimeout(this.timer[name]);
      }, 1000);
    },
    async onSendSign() {
      this.sending = true;
      const api = this.api + "/kontur/sendsign/" + this.id;
      try {
        const d = await this.$axios.get(api);
        console.log(d.data);
        if (d.data && d.data?.status == "ok") {
          this.$root.$emit("show-info", {
            time: 10000,
            text: `Документ отправлен в СЭП "Контур"`,
          });
          this.$emit("success");
          this.dialog = false;
        } else
          this.$root.$emit("show-info", {
            type: "error",
            text: `Ошибка при отправки в СЭП "Контур"`,
          });
      } catch (error) {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Ошибка " + error?.data?.message,
        });
      }
      this.$emit("success");

      this.delay("send", 60);
      setTimeout(() => {
        this.sending = false;
      }, 60000);
    },
    async onGetCode() {
      this.sending = true;
      try {
        const d = await this.$axios.get(this.api + "/kontur/getconfirm/" + this.id);
        console.log(d.data);
        if (d.data && d.data?.status == "ok") {
          this.$root.$emit("show-info", {
            time: 10000,
            text: `СМС с кодом отправлена на номер стороны 1  `,
          });
        } else
          this.$root.$emit("show-info", {
            type: "error",
            text: "Ошибка при отправки СМС",
          });
      } catch (error) {
        let err = error?.message || error?.data?.message;
        err = this.parseError(err);
        this.$root.$emit("show-info", {
          type: "error",
          text: "Ошибка: " + err,
        });
      }
      this.delay("send", 60);
      setTimeout(() => {
        this.sending = false;
      }, 60000);
    },
    async onSendCode() {
      this.confirming = true;
      try {
        const d = await this.$axios.post(this.api + "/kontur/sendconfirm/" + this.id, { code: this.code });
        if (d.data && d.data?.status == "ok") {
          this.$root.$emit("show-info", {
            text: "Код принят",
          });
          this.$emit("success");
          this.dialog = false;
        } else
          this.$root.$emit("show-info", {
            type: "error",
            text: "Не верный код",
          });
      } catch (error) {
        let err = error?.message || error?.data?.message;
        err = this.parseError(err);
        this.$root.$emit("show-info", {
          type: "error",
          text: "Ошибка: " + err,
        });
      }
      this.code = null;
      this.delay("confirm", 5);

      setTimeout(() => {
        this.confirming = false;
      }, 12000);
    },
    onClose(v = true) {
      if (v) this.$emit("success");
      this.dialog = false;
    },
  },
};
</script>
